import usePlans from "@/hooks/usePlans";

/**
 * Audience gate for the abandoned-checkout promo (r-1913): users with no
 * active paid plan who abandoned a started checkout. Abandonment is passed in
 * because the two call sites read it differently (the persistently mounted
 * banner tracks it across navigation, the auto-apply reads it once on mount).
 */
export default function useAbandonedCheckoutPromoEligibility(
  hasAbandonedCheckout: boolean
) {
  const { data: plans } = usePlans();
  const activePlans =
    plans?.results?.filter((plan) => plan.status === "active") ?? [];
  const hasPaidPlan = activePlans.some((plan) => plan.proxy_type !== "free");

  return hasAbandonedCheckout && Boolean(plans) && !hasPaidPlan;
}
